import { useCounts } from './useInventory';
import { formatCurrency } from '../../shared/utils/format';
import { LoadingSkeleton } from '@nexora/design-system';

export function CountHistory({ warehouseId }: { warehouseId: string }): JSX.Element {
  const { data, isLoading } = useCounts({ warehouseId, limit: 10 });
  const rows = data?.data ?? [];

  if (isLoading) {
    return <LoadingSkeleton count={2} height="40px" />;
  }
  if (rows.length === 0) {
    return (
      <p className="cnt-hint">
        Nenhuma contagem registrada neste armazém — registre a primeira acima.
      </p>
    );
  }
  return (
    <div className="cnt-history">
      <h3 className="cnt-history-title">Histórico de contagens</h3>
      <ul className="cnt-history-list">
        {rows.map((count) => {
          const divergentes = count.items.filter((i) => i.discrepancy !== 0).length;
          const total = count.items.reduce(
            (soma, i) => soma + (i.countedQuantity - i.expectedQuantity) * i.unitCost,
            0,
          );
          return (
            <li key={count.id} className="cnt-history-item">
              <span>
                {new Date(count.createdAt).toLocaleString('pt-BR')} · {count.items.length}{' '}
                {count.items.length === 1 ? 'item' : 'itens'} · {divergentes} com divergência
              </span>
              <strong className={total === 0 ? 'cnt-flat' : total > 0 ? 'cnt-up' : 'cnt-down'}>
                {formatCurrency(total)}
              </strong>
            </li>
          );
        })}
      </ul>
      <style>{`
        .cnt-history { margin-top: 16px; }
        .cnt-history-title { font-size: 12px; font-weight: 600; color: #43474e; margin: 0 0 8px; }
        .cnt-history-list { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 8px; }
        .cnt-history-item { display: flex; justify-content: space-between; gap: 12px; font-size: 12px; color: #191c1e; border: 1px solid #eceef0; border-radius: 8px; padding: 8px 12px; }
      `}</style>
    </div>
  );
}
